import { render, staticRenderFns } from "./CopyCode.vue?vue&type=template&id=24760eea&"
import script from "./CopyCode.vue?vue&type=script&lang=js&"
export * from "./CopyCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports